import React from 'react';
import {Link} from "react-router-dom";

export default function NavBar(){

     return (
	  <div>
		 {/* <div className="header-top" style={{"padding":"3px 0px","background-color":"GREEN"}}>
			<div className="auto-container">
			  <div className="clearfix">
				<div id="latestupdate" style={{"color":"white","font-size":"15px","font-weight":"600"}}>
				  <marquee onmouseover="this.stop();" onmouseout="this.start();">
					<strong>Latest Update :  &nbsp;  <i className="fa fa-download" style={{"font-size":"16px"}}><a style={{"color":"white"}} href="download/Financial_Results/Annual-Report-2024.pdf" target="_Blank"> Annual Report 2024 </a></i>
					  &nbsp; | <i className="fa fa-download" style={{"font-size":"16px"}}><a style={{"color":"white"}} href="download/notice/Notice-of-13th-Agm.pdf" target="_Blank"> Notice of 13th Agm</a></i>
					  &nbsp; | <i className="fa fa-download" style={{"font-size":"16px"}}><a style={{"color":"white"}} href="download/notice/Attendence_Slip.pdf" target="_Blank"> Attendence Slip</a></i>
					</strong></marquee>
				</div>
			  </div>
			</div>
		 </div>*/}
		  <nav className="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0 px-4 px-lg-5">
				<Link to="/" className="navbar-brand d-flex align-items-center">
				  <h2 className="m-0 text-primary"><img className="img-fluid me-2" src="assets/img/logo.PNG" alt="logo" style={{"width":"150px"}} /></h2>
				</Link>
				<button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
				  <span className="navbar-toggler-icon" />
				</button>
				<div className="collapse navbar-collapse" id="navbarCollapse">
				  <div className="navbar-nav ms-auto py-4 py-lg-0">
					<Link to="/" className="nav-item nav-link" >Home</Link>
					<Link to="/about" className="nav-item nav-link">About</Link>
					<div className="menu nav-item">
					  <div className="menu-item nav-item nav-link">
						Investor Relation <i className="fa fa-caret-down" aria-hidden="true" />
						<div className="submenu">
							<Link to="disclosures-under-regulation" className="dropdown-item">Disclosures under Regulation 46 of SEBI (LODR) Regulation, 2015</Link>
							<div className="submenu-item has-submenu dropdown-item">
								Integrated filling
								<div className="nested-submenu left-side">
								  <Link to="integrated-governance" className="dropdown-item">Integrated Governance</Link>
								  <Link to="integrated-financial" className="dropdown-item">Integrated Financial</Link>
								</div>
							  </div>
							<Link to="other-filings-with-stock-exchange" className="dropdown-item">Other Filings with stock exchange</Link>
							<Link to="annual-secretarial-compliance-report" className="dropdown-item">Annual Secretarial compliance Report</Link>
							<Link to="corporate-governance" className="dropdown-item">Compliance Report on Corporate Governance</Link>
							<Link to="financial-result" className="dropdown-item">Financial Results</Link>
							<Link to="regulation-30" className="dropdown-item">Regulation 30</Link>
							<Link to="moa-aoa" className="dropdown-item">Moa & Aoa</Link>
							 <div className="submenu-item has-submenu dropdown-item">
								Board Of Director's & Board Meetings
								<div className="nested-submenu left-side">
								  <Link to="board-of-director" className="dropdown-item">Board Of Director's</Link>
								  <div className="nested-item ">
									Board Meetings <br />
									<Link to="intimation" className="nav-item nav-link">Intimation </Link>
					                <Link to="outcome-of-board-meeting" className="nav-item nav-link">Outcome</Link>
								  </div>
								</div>
							  </div>
							<Link to="shareholding-pattern" className="dropdown-item">Shareholding Pattern</Link>
							<Link to="committees-of-board" className="dropdown-item">Committees Of Board</Link>
							<Link to="#" className="dropdown-item">Investor Information</Link>
							<Link to="annual-general-meeting" className="dropdown-item">General Meetings & Postal Ballot</Link>
							<Link to="annual-return" className="dropdown-item">Annual Return</Link>
							<Link to="annual-reports" className="dropdown-item">Annual Reports</Link>
							<Link to="codes-policies" className="dropdown-item">Codes & Policies</Link>
							<Link to="#" className="dropdown-item">Prospectus</Link>
							<Link to="press-release-&-announcement" className="dropdown-item">Press Release & Announcement</Link>
							<Link to="#" className="dropdown-item">Unclaimed Dividend</Link>
							<Link to="#" className="dropdown-item">Scheme of Amalgamation</Link>
							
							
						</div>
					  </div>
					</div>
					
					
					
					<Link to="#" className="nav-item nav-link">News</Link>
					<Link to="/contact" className="nav-item nav-link">Contact Us</Link>
				   
				  </div>
				  
				</div>
			  </nav>
		</div>
    );
}